import type { HTTPService } from "@soft-db/http";

export type SpaceUpdate = {
	name: string;
	features: SpaceFeatures;
};

export type Space = {
	id: string;
	distributor: string;
	logoUrl: string;
	archived: boolean;
	users: number;
	publicPage: number;
	sites: number;
	stations: number;
	reports: number;
} & SpaceUpdate;

export type SpaceFeatures = {
	dashboard: boolean;
	integrity: boolean;
	report: boolean;
	audit: boolean;
};

export class SpaceApi {
	constructor(private _http: HTTPService) {}

	async fetch(id: string) {
		return await this._http.get<Space>(`spaces/${id}`);
	}

	async fetchContext() {
		return await this._http.get<Space[]>(`spaces`);
	}

	async updateLogo(id: string, file: File) {
		return await this._http.postFile<Space>(`spaces/${id}/logo`, "file", file);
	}

	async deleteLogo(id: string) {
		return await this._http.delete<Space>(`spaces/${id}/logo`);
	}

	async updateSpace(id: string, space: SpaceUpdate) {
		return await this._http.patch<Space>(`spaces/${id}`, space);
	}

	async addSite(id: string, siteId: string, isOwner?: boolean) {
		return await this._http.post<void>(`spaces/${id}/sites/${siteId}`, { isOwner });
	}

	async deleteSite(id: string, siteId: string) {
		return await this._http.delete<void>(`spaces/${id}/sites/${siteId}`);
	}

	async addStation(id: string, stationId: string) {
		return await this._http.post<void>(`spaces/${id}/stations/${stationId}`);
	}

	async deleteStation(id: string, stationId: string) {
		return await this._http.delete<void>(`spaces/${id}/stations/${stationId}`);
	}

	async createSpace(id: string, space: SpaceUpdate) {
		return await this._http.post<Space>(`distributors/${id}/spaces`, space);
	}

	async fetchDistSpaces(id: string) {
		return await this._http.get<Space[]>(`distributors/${id}/spaces`);
	}

	async addReport(id: string, reportId: string) {
		return await this._http.post<void>(`spaces/${id}/reports/${reportId}`);
	}

	async deleteReport(id: string, reportId: string) {
		return await this._http.delete<void>(`spaces/${id}/reports/${reportId}`);
	}
}
